module.exports = __webpack_public_path__ + "img/volver icon.462917de.svg";